import React from 'react'
import styled, { css } from 'styled-components'

const width = '25'
const height = '21'
const viewBox = '0 0 25 21'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#9AA3B3"
      fillOpacity=".3"
      d="M14.438 0v10.106h5.775a5.775 5.775 0 0 1-5.775 5.775v4.332c5.582 0 10.106-4.525 10.106-10.107V0H14.438zM0 10.106h5.775A5.775 5.775 0 0 1 0 15.881v4.332c5.582 0 10.106-4.525 10.106-10.107V0H0v10.106z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'BlockquoteClose'
})
